import React, { Component, CSSProperties, ReactElement } from 'react';
import Dropdown from '@tencent/dui/lib/components/Dropdown';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import classNames from 'classnames';
import { DROPDOWN_ICON } from '@src/framework/workbench/drawer/image';
import Style from './index.less';

type IFormItemDropdownState = {
    isChecked?: boolean;
};

type IFormItemDropdownProps = {
    checked?: boolean;
    icon: any;
    dropContent: ReactElement;
    onClick: any;
    style?: CSSProperties;
    dropContentStyle?: CSSProperties;
    colorBtnStyle?: CSSProperties;
    paragraphIconStyle?: CSSProperties;
    text?: string;
    dropDownProps?: any;
    tooltip?: any;
    dropDownIconStyle?: CSSProperties;
    btnDisable?: boolean;
    onDropdownVisibleChange?: (visible: boolean) => void;
};

export const getTooltipProps = (tooltipText?: string) => ({
    title: tooltipText,
    disabled: !tooltipText,
    className: Style['dropdown-tooltip'],
    hideOnClick: true,
});

/**
 * 左侧按钮可点击触发事件，右侧下拉图标为dropdown
 */
export default class FormItemDropdown extends Component<IFormItemDropdownProps, IFormItemDropdownState> {
    public static getDerivedStateFromProps(props, state) {
        // 有更新的时候再刷新
        if (state.isChecked !== props.checked) {
            return {
                isChecked: props.checked,
            };
        }
        return null;
    }

    public constructor(props) {
        super(props);
        this.state = {
            isChecked: this.props.checked,
        };
    }

    public render() {
        const wrapperClass = classNames({
            [Style['form-item-dropdown-wrapper']]: true,
            [Style['form-item-dropdown-wrapper-checked']]: this.state.isChecked,
        });
        const btnClass = classNames({
            [Style['form-item-icon']]: true,
            [Style['form-item-icon-disable']]: this.props.btnDisable,
        });
        return (
            <Tooltip {...getTooltipProps(this.props.tooltip)}>
                <div className={wrapperClass} style={this.props.style}>
                    <div className={btnClass} onClick={this.props.onClick} style={this.props.paragraphIconStyle}>
                        <img src={this.props.icon} alt={''}/>
                        {this.props.text
                            ? <span className={Style['form-item-text']}>{this.props.text}</span>
                            : null
                        }
                    </div>
                    <Dropdown
                        dropContent={this.props.dropContent}
                        dropContentStyle={this.props.dropContentStyle}
                        onVisibleChange={this.props.onDropdownVisibleChange}
                    >
                        <div className={Style['form-item-dropdown-icon']} style={this.props.dropDownIconStyle}>
                            <img src={DROPDOWN_ICON} alt={''}></img>
                        </div>
                    </Dropdown>
                </div>
            </Tooltip>);
    }
}
